const React = require("react");
const PT = require("prop-types");
const createReactClass = require("create-react-class");
const {atPage} = require("../../core/vault/StateCursors");
const AT = require("../../core/vault/ActionTypes");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const withOfficeErrorCatching = require("../../core/hoc/withOfficeErrorCatching");
const Slots = require("../../core/vault/Slots");
const _ = require("lodash");
const ParentUtil = require("../../parent/util/ParentUtil");
const LoadGuard = require("../../core/view/LoadGuard");
const styles = require("./styles/PageGiftBucksConfirmation.css");

const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(
		Component,
		(props, vaultState) => ({
			page: atPage(vaultState).get(),
			parentData: Slots.getValue(vaultState, Slots.table.parentData()),
		}),
		{forLoggedIn: true}
	);
	Component = withOfficeErrorCatching(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "PageGiftBucksConfirmation",

		propTypes: {
			// Injected by HOCs
			dispatch: PT.func.isRequired,
			page: PT.object.isRequired,
			parentData: PT.object.isRequired,
		},

		// Check if the parent data needs to be reloaded. Required to populate parentData.
		getInitialState: function() {
			if (_.get(this.props.parentData, "needsDataReload", false)) {
				this.props.dispatch({type: AT.PARENT_OFFICE_STUDENT_DATA_RELOAD});
			}
			return {
				filters: {},
				reactCrashed: false,
				showSuccessMessage: false,
				showErrorMessage: false,
			};
		},

		vaultEvents: {
			oneOffRewardAddSuccess: function() {
				this.setState({showSuccessMessage: true});
			},
			oneOffRewardAddFailed: function() {
				this.setState({showErrorMessage: true});
			},
		},

		/**
		 * Add a one-off reward of 100 bucks for the student.
		 */
		onClickConfirmGift: function() {
			this.props.dispatch({
				type: AT.ADD_ONE_OFF_REWARD_REQUEST,
				payload: {
					userID: this.props.page.studentID,
					eventType: "riverCrossing",
					bucks: 100,
					triggeredBy: "parent",
				},
			});
		},

		/**
		 * Handle the "No, thanks" button click. Instead of recording a denial in the database,
		 * just show a success message. Parents can refresh the page to change their mind.
		 */
		onClickDenyGift: function() {
			this.setState({showSuccessMessage: true});
		},

		renderPageContent: function(message, options = {}) {
			const {includeActionButtons = false} = options;
			return (
				<div className={styles.giftBucksConfirmationContainer}>
					<div className={styles.giftBucksConfirmation}>
						<h1>Gift Bucks Confirmation</h1>
						<div className={styles.confirmationContent}>
							<p>{message}</p>
						</div>
						{includeActionButtons && (
							<div className={styles.actions}>
								<button
									className={styles.btnPrimary}
									onClick={this.onClickConfirmGift}
								>
									Yes, send 100 bucks
								</button>
								<button
									className={styles.btnPrimary}
									onClick={this.onClickDenyGift}
								>
									No, thanks
								</button>
							</div>
						)}
					</div>
				</div>
			);
		},

		/**
		 * Render the component when the parent data is loaded.
		 */
		renderLoaded: function() {
			// Show success message once the parent has responded.
			if (this.state.showSuccessMessage) {
				return this.renderPageContent(
					"Your response has been recorded. If you responded 'No, thanks', you can refresh the page if you change your mind."
				);
			}
			if (this.state.showErrorMessage) {
				return this.renderPageContent(
					"An error occurred while recording your response. Please try again later."
				);
			}

			const studentsData = ParentUtil.getActiveOrRegisteredStudents(
				this.props.parentData
			);

			// Check that the studentID provided in the URL belongs to a child of the parent.
			if (!studentsData[this.props.page.studentID]) {
				return this.renderPageContent(
					"You are not authorized to access this page. Please contact your administrator."
				);
			}

			const oneOffRewards = _.get(
				studentsData,
				[this.props.page.studentID, "oneOffRewards"],
				[]
			);
			// TODO: Generalize this to other events in the future.
			const riverCrossingRewards = oneOffRewards.filter(
				reward => reward.eventType === "riverCrossing"
			);

			// If the one-off reward for this event type has already been handled by the parent,
			// show a message to the parent. This is to prevent the parent from being able to
			// send the gift multiple times.
			if (riverCrossingRewards.length > 0) {
				return this.renderPageContent(
					"You have already completed this action."
				);
			}

			const studentName = studentsData[this.props.page.studentID].displayName;
			return this.renderPageContent(
				`Do you want to send a gift of 100 bucks to your student, ${studentName}?`,
				{includeActionButtons: true}
			);
		},

		render: function() {
			const requestLoad = () =>
				this.props.dispatch({
					type: AT.LOAD_PARENT_DATA_SLOT_REQUEST,
				});

			return (
				<div className={styles.main}>
					<LoadGuard
						identifier="officeParent"
						status={this.props.parentData}
						requestLoad={requestLoad}
						loadingView={"logo"}
						logoColorType={"color"}
						loadingViewClass={styles.loading}
						errorView="refreshOffice"
						renderLoaded={this.renderLoaded}
					/>
				</div>
			);
		},
	})
);
